module.exports = __webpack_public_path__ + "img/canada-external-causes-male.4b1c0990.png";